import { lookupSkillIcon } from '#pplx/frontend/apps/ask/skill-cards/skillIconRegistry.js';
import { $icon } from '#pplx/frontend/icons/icon-sprite.js';
export const PLUGIN_ICON = $icon('plug');
// First-party skill-name aliases; server icon names resolve via the shared
// skill icon registry.
const MENU_ICON_ALIASES = {
    research: $icon('telescope'),
    'deep-research': $icon('telescope'),
    'model-council': $icon('gavel'),
    'computer-learn': $icon('book'),
    loop: $icon('clipboard-list'),
    'create-skill': $icon('plus'),
    incognito: $icon('spy'),
    'control-local-browser': $icon('click'),
    'arrow-fork': $icon('arrow-fork'),
};
export function getMenuIcon(name) {
    // Callers pass either a server icon name or a skill name (e.g. "Research"),
    // so normalize case to match the lowercase keys above.
    const key = name.trim().toLowerCase();
    const alias = Object.hasOwn(MENU_ICON_ALIASES, key) ? MENU_ICON_ALIASES[key] : undefined;
    return lookupSkillIcon(key) ?? alias ?? $icon('blocks');
}
//# sourceMappingURL=getMenuIcon.js.map